import { NgClass } from '@angular/common';
import { Component, input } from '@angular/core';

import { MessageType } from '../../../../model/message.model';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'show-message',
    templateUrl: 'message-component.html',
    imports: [NgClass],
})
export class MessageComponent {
    readonly type = input<MessageType>();
    readonly showHeader = input<boolean>(false);
    readonly showClose = input<boolean>(false);
    readonly showIcon = input<boolean>(true);
    readonly showLink = input<boolean>(false);
    readonly messageText = input<string>('');
    readonly id = input('default-message');

    constructor() {}

    public get messageType(): typeof MessageType {
        return MessageType;
    }
}
